import { forwardRef, type Ref, type SVGProps } from "react";
const IconAwardRibbonOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="m29.8 23.66-3.59-4.88a11.3 11.3 0 0 0 1.29-5.28 11.5 11.5 0 0 0-23 0 11.3 11.3 0 0 0 1.29 5.28L2.2 23.66a.98.98 0 0 0-.13.96 1 1 0 0 0 .76.62l3.91.68 1.81 3.53a1.01 1.01 0 0 0 .81.55h.08a1 1 0 0 0 .8-.41l3.55-4.8a11.7 11.7 0 0 0 4.42 0l3.55 4.8a1 1 0 0 0 .8.41h.08a1.01 1.01 0 0 0 .81-.55l1.81-3.53 3.91-.68a1 1 0 0 0 .76-.62.98.98 0 0 0-.13-.96M9.59 27.1 8.3 24.56a1 1 0 0 0-.72-.53l-2.81-.49 2.18-2.96a11.46 11.46 0 0 0 4.8 3.6Zm7.3-4.14a10 10 0 0 1-1.78 0 9.5 9.5 0 0 1-3.36-.96 9.7 9.7 0 0 1-2.58-1.9 9.4 9.4 0 0 1-2-3.09 9.5 9.5 0 1 1 17.66 0 9.4 9.4 0 0 1-2 3.09 9.7 9.7 0 0 1-2.58 1.9 9.5 9.5 0 0 1-3.36.96m7.53 1.07a1 1 0 0 0-.72.53l-1.29 2.54-2.16-2.92a11.46 11.46 0 0 0 4.8-3.6l2.18 2.96Z"
    />
    <path
      fill="currentColor"
      d="M20.75 12.97c.44-.48.28-.97-.36-1.09l-2.59-.48-1.26-2.46c-.3-.59-.78-.59-1.08 0L14.2 11.4l-2.59.48c-.64.12-.8.61-.36 1.09l1.84 2-.37 2.78c-.08.64.32.93.91.63l2.37-1.2 2.37 1.2c.59.3.99.01.91-.63l-.37-2.78Z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconAwardRibbonOutlineSVG);
ForwardRef.displayName = "IconAwardRibbonOutline";
export { ForwardRef as IconAwardRibbonOutline };
